<template>
	<div v-if="season_mare_local">
		<h2>{{ $t('gynecologie.choix_objectifs_pour') }} {{ season_mare_local.horse.horse_nom }} {{ $t('gynecologie.en') }} {{ season_local.name }}</h2>

		<div class="form-row align-items-center">
			<div class="col-1">#</div>
			<div class="col-3">{{ $t('horse.etalon') }}</div>
			<div class="col-3">{{ $t('gynecologie.goal') }}</div>
			<div class="col-4">{{ $t('monte.status_contract') }}</div>
			<div class="text-right col-1">
				<b-button variant="primary" @click.prevent="openAddGoal">{{ $t('global.ajouter') }} <font-awesome-icon :icon="['fal', 'plus']" /></b-button>
			</div>
		</div>
		<LoadingSpinner v-if="loading" />
		<draggable v-else class="list-group list-group-left" :list="goals" v-bind="dragOptions" group="colonne" @update="debouncedOrder">
			<div v-for="(goal, index) in goals" class="list-group-item align-items-center" :key="goal.seasonmaregoals_id">
				<div class="form-row align-items-center">
					<div class="col-1">
						{{ index+1 }} <b-button variant="secondary" class="ml-2 order-md-last"><font-awesome-icon :icon="['fal', 'sort-alt']" /></b-button>
					</div>
					<div class="col-3"><router-link :to="{ name: 'HorseFicheInfo', params: { horse_id: goal.horse.horse_id }}">{{ goal.horse.horse_nom }}</router-link></div>
					<div class="col-3">{{ $t('gynecologie.goal_type.'+goal.seasonmaregoals_type) }}</div>
					<div class="col-4">
						<span v-if="goal.seasonmaregoals_type == 'congele' && !isOnline">{{ $t('error.LNOC') }}</span>
						<span v-else>
							<font-awesome-icon v-if="!goal.status" style="color:red;" :icon="['fal', 'times']" />
							{{ goal.status }} <template v-if="goal.porteuse && goal.porteuse.horse"> - <router-link :to="{ name: 'HorseFicheInfo', params: { horse_id: goal.porteuse.horse.horse_id }}">{{ goal.porteuse.horse.horse_nom }}</router-link></template>
							<template v-if="goal.contract_num"> - {{ $t('monte.numero_contrat') }} {{ goal.contract_num }}</template>
						</span>
					</div>
					<div class="text-right col-1">
						<b-button variant="primary" @click.prevent="openConfirmDeleteGoal(goal)"><font-awesome-icon :icon="['fal', 'trash-alt']" /></b-button>
					</div>
			    </div>
			</div>
		</draggable>

		<b-modal ref="modal-protocole" hide-footer>
			<template v-slot:modal-title>
				{{ $t('gynecologie.add_goal') }}
			</template>

			<div class="row">
				<div class="col-4">
					<label>{{ $t('horse.etalon') }}*</label>
				</div>
				<div class="col-6">
                    <e-select
                        v-model="goal_horse"
                        id="horses"
                        track-by="horse_nom"
                        label="horse_nom"
                        :options.sync="horses"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                    >
                        <template slot="singleLabel" slot-scope="{ option }">{{ option.horse_nom }}</template>
                        <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                    </e-select>
				</div>
				<div class="col-4">
					<label>{{ $t('gynecologie.type_goal') }}*</label>
				</div>
				<div class="col-6">
					<e-select
						id="goal_type"
						v-model="goal_type"
						:options="goal_types"
                        :allow-empty="false"
					>
	                    <template slot="option" slot-scope="{ option }">{{ $t('gynecologie.goal_type.'+option) }}</template>
	                    <template slot="singleLabel" slot-scope="{ option }">{{ $t('gynecologie.goal_type.'+option) }}</template>
						<template slot="noOptions">{{ $t('global.list_empty') }}</template>
					</e-select>
				</div>
			</div>

			<div class="text-center">
				<a class="btn btn-primary mt-3" href="#" @click.prevent="checkForm">{{ $t('global.enregistrer') }} <font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'save']" /></a>
			</div>
		</b-modal>
	</div>
</template>

<script type="text/javascript">
    import Gynecologie from "@/mixins/Gynecologie.js"
    import PlanningMonte from "@/mixins/PlanningMonte.js"
    import draggable from 'vuedraggable'
    import _debounce from 'lodash/debounce'
    import _isEmpty from 'lodash/isEmpty'

	export default {
		name: 'Goals',
		props: ['season', 'season_mare', 'mare_id', 'date'],
		mixins: [Gynecologie, PlanningMonte],
		data () {
			return {
				loading: false,
				processing: false,
				season_local: null,
				season_mare_local: null,
				goals: [],
                dragOptions: {
                    animation: 200
                },
                debouncedOrder: _debounce(this.updateOrder, 500),
                horses: [],
                goal_horse: null,
                goal_types: ['porte', 'transplante', 'congele'],
                goal_type: ''
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
				if(this.mare_id && this.date && !this.season_mare) {
					const seasons = await this.getCurrentSeason(this.date)
					if(seasons.length == 0) return false
					this.season_local = seasons[0]
					this.season_local.name = this.season_local.season_label
					const season_mares = await this.loadSeasonMareBySeasonHorse(this.mare_id, this.season_local.season_id, true)
					if(season_mares.length == 0) return false
					this.season_mare_local = season_mares[0]
				}
				else {
					this.season_local = this.season
					if(this.season.season_label)
						this.season_local.name = this.season.season_label
					this.season_mare_local = this.season_mare
				}

				if(!this.season_mare_local) {
					return false
				}

				this.goals = await this.getGoalsBySeasonMare(this.season_mare_local)
				this.loading = false

				if(this.horses.length == 0) {
					this.horses = await this.getHorsesStallion(false)
				}
			},

			async updateOrder() {
				const orders = {}
				this.goals.forEach((goal, index) => {
					orders[index] = goal.seasonmaregoals_id
				})
				await this.saveGoalOrder(orders)
				this.successToast('toast.info_save_succes')
				this.init_component()
			},

			openConfirmDeleteGoal() {

			},

			openAddGoal() {
				this.goal_horse = null
				this.goal_type = null
				this.$refs['modal-protocole'].show()
			},

			async checkForm() {
				if(!this.goal_horse || _isEmpty(this.goal_type)) {
					this.failureToast("formulaire.erreur_champs_non_remplis")
					return false
				}
				this.processing = true
				await this.saveGoal(this.season_mare_local.seasonmare_id, this.goal_horse.horse_id, this.goal_type)
				this.processing = false
				this.$refs['modal-protocole'].hide()
				this.init_component()
			}
		},

		watch: {
			date() {
				this.init_component()
			}
		},

		computed: {
			isOnline() {
				return window.navigator.onLine
			}
		},

		components: {
            LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
            draggable 
		}
	}

</script>